export default __webpack_public_path__ + "1c6ded137f17df60b0a83ac0b16cc8c9.glb";